module.exports = __webpack_public_path__ + "img/left-bottom-radius.43dfa3d6.svg";